const locale = require('./newAttachmentModal.i18n.json');

/*@ngInject*/
const NewAttachmentModalController = function ($rootScope, $scope, $timeout, options, coreMediator, coreConstant, preferenceModel, attachmentUtil, isUnderwriterUser, fullOptionsForm, existingFile) {

    $scope.i18n = locale;

    $scope.viewModel = {
        attachment: {},
        typeDataItems: null,
        uploadedFile: null,
        isUnderwriterUser: isUnderwriterUser,
        fullOptionsForm: fullOptionsForm
    };

    $scope.onConfirm = function () {
        $scope.$close({attachment: $scope.viewModel.attachment, file: $scope.viewModel.uploadedFile});
    };

    $scope.onCancel = function () {
        $scope.$dismiss();
    };

    $scope.storeUploadedFile = function (uploadedFile) {
        if (uploadedFile && attachmentUtil.validateAttachment(uploadedFile, _.get($scope.i18n, 'unacceptableTypeAndSize'))) {
            $timeout(function () {
                $scope.viewModel.uploadedFile = uploadedFile;
                if (!$scope.viewModel.attachment) {
                    $scope.viewModel.attachment = {};
                }
                $scope.viewModel.attachment.name = uploadedFile.name;
                $scope.viewModel.attachment.size = uploadedFile.size;
                $scope.viewModel.attachment.byteCountToDisplaySize = attachmentUtil.convertAttachmentSize(uploadedFile.size);
            }, 0);
        }
    };

    $scope.$on(coreConstant.event.FILE_DROPPED, function (event, file) {
        $scope.storeUploadedFile(file);
    });

    $scope.resetTypeDropdown = function () {
        $scope.viewModel.attachment.type = '';
    };

    $scope.setTypeValue = function (value) {
        $scope.viewModel.attachment.type = value;
    };

    $scope.getTypeLabel = function (type) {
        let item = _.find($scope.viewModel.typeDataItems, (item) => {
            return item.value==type;
        });
        return item.name;
    };

    $scope.canEnableConfirmButton = function () {
        return $scope.viewModel.attachment.name;
    };

    function loadDataSets() {
        attachmentUtil.getAttachmentTypes().then(function (result) {
            $scope.viewModel.typeDataItems = result;
        });
    }

    function init() {

        $scope.viewModel = _.assign($scope.viewModel, {
            title: options.title ? options.title : $scope.i18n.title,
            cancelButton: options.cancelButtton ? options.cancelButton : $scope.i18n.cancelButton,
            uploadButton: options.uploadButton ? options.uploadButton : $scope.i18n.uploadFile,
            chooseFileString: options.chooseFileString ? options.chooseFileString : $scope.i18n.chooseFile,
            pleaseChooseString: options.pleaseChooseString ? options.pleaseChooseString : $scope.i18n.type,
            fileDescPlaceholder: options.fileDescPlaceholder ? options.fileDescPlaceholder : $scope.i18n.fileDescription
        });

        if (existingFile) {
            $scope.storeUploadedFile(existingFile);
        }

        loadDataSets();
    }

    $scope.fileSelected = function (file) {
        if (file) {
            $scope.storeUploadedFile(file);
        }
    };

    init();

    $scope.$on(coreConstant.event.MODAL_CLOSING, function () {
        $rootScope.$broadcast(coreConstant.event.MODAL_CLOSED);
    });

    $rootScope.$broadcast(coreConstant.event.MODAL_OPENED);
};

angular.module('gw-um-submission')
    .controller('newAttachmentModalController', NewAttachmentModalController);
